module.exports = __webpack_public_path__ + "static/media/knab.710ade4a.png";